export default [
  {
    path: "/volunteer",
    name: "Volunteer",
    component: () => import("@/views/volunteer/Volunteer.vue"),
    meta: {
      forAuth: true,
    },
  },
  {
    path: "/training/:id",
    name: "training",
    component: () => import("@/views/volunteer/training/Training.vue"),
    meta: {
      forAuth: true,
    },
  },
];
